module.exports = __webpack_public_path__ + "static/img/23-businessanalytics.ed33439.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-businessanalytics.png
// module id = yG8X
// module chunks = 1